import * as React from "react";
const SvgXIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 17L17 7M17 17L7 7", stroke: "#FF5858", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgXIcon;
